<template>
  <v-layout column>
    <v-flex xs12 v-if="orderId == null">
      <v-card class="elevation-3 pa-2" v-sticky sticky-offset="{ top: 65 }">
        <v-container>
          <v-layout row>
            <v-flex xs12 sm3>
              <v-btn
                color="primary"
                :disabled="!canMakeOrder"
                @click.stop="viewOrder"
              >
                <v-icon>{{ icons.send }}</v-icon
                >&nbsp;Отправить заявку
              </v-btn>
            </v-flex>

            <v-flex xs12 sm4>
              <v-chip label outlined color="primary" class="mt-1">
                <v-icon>{{ icons.sigma }}</v-icon>
                Сумма: {{ this.basketTotal | twoDecimalPoint }} РОЦ руб.
              </v-chip>
            </v-flex>

            <v-flex xs12 sm5 align-self-center class="text-right">
              Цены от
              <span
                class="primary white--text"
                v-if="currentProductPrices && currentProductPrices[0]"
              >
                {{ currentProductPrices[0].updated | datetime }}</span
              >
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
    <v-flex xs12 class="my-4">
      <Points
        v-if="this.orderId == null"
        :points="points"
        :selectedPoints="selectedPoints"
        v-on:add-points="addPoints"
        v-on:remove-point="removePoint"
      />
    </v-flex>
    <v-flex>
      <Price
        v-if="this.orderId == null"
        :products="currentProductPrices"
        :points="selectedPoints"
        :productTypes="productTypes"
        :productsStates="currentProductsStates"
      />
      <OrderView v-else :order="this.order" />
    </v-flex>
    <v-dialog persistent v-model="dialogOrder" max-width="800px">
      <v-card>
        <v-toolbar flat dark color="primary">
          <v-toolbar-title>
            <span class="headline">Новый заказ</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="onCancelOrder">
              <v-icon>{{ icons.close }}</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <OrderEdit
            :order="this.order"
            v-on:update-quantity="updateQuantity"
          />
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-col cols="12" sm="5" offset-sm="1">
              <excel
                :name="excelName"
                :fields="excelOrderFields"
                :data="this.order.items"
              >
                <v-btn outlined color="primary">
                  <v-icon>{{ icons.export }}</v-icon
                  >&nbsp;Экспорт в Excel
                </v-btn>
              </excel>
            </v-col>
            <v-col cols="4" sm="2">
              <v-btn outlined color="primary" @click="onCancelOrder"
                >Отмена</v-btn
              >
            </v-col>
            <v-col cols="8" sm="2">
              <v-btn
                dark
                color="primary"
                :disabled="!canMakeOrder"
                @click="onSaveOrder"
                >Отправить заявку</v-btn
              >
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import { Icon } from "@/helpers";

const Price = () => import("@/components/Orders/Price");
const OrderView = () => import("@/components/Orders/OrderView");
const OrderEdit = () => import("@/components/Orders/OrderEdit");
const Points = () => import("@/components/_common/Points");

export default {
  components: {
    Price,
    OrderView,
    OrderEdit,
    Points,
  },
  computed: {
    ...mapState({
      selectedOrderItems: (state) => state.orders.selectedOrderItems,
      points: (state) => state.points.points,
      selectedPoints: (state) => state.points.selectedPoints,
      productPrices: (state) => state.products.productPrices,
      productTypes: (state) => state.products.productTypes,
      selectedProductTypes: (state) => state.products.selectedProductTypes,
      isColdZone: (state) => state.products.selectedColdZone,
      isCountryBelarus: (state) => state.products.selectedCountryBelarus,
      productsState: (state) => state.products.productsState,
      user: (state) => state.users.user,
      orders: (state) => state.orders.orders,
      orderItems: (state) => state.orders.orderItems,
      basket: (state) => state.baskets.basket,
    }),
    ...mapGetters({
      basketTotal: "baskets/BASKET_TOTAL",
    }),
    orderId() {
      return this.$route.params.id;
    },
    currentProductsStates: function () {
      if (
        this.selectedPoints &&
        this.selectedPoints != null &&
        this.selectedPoints.length > 0
      ) {
        return this.productsState.filter((item) =>
          this.selectedPoints.find((point) => {
            return point.pointId == item.pointId;
          })
        );
      } else return [];
    },
    excelName: function () {
      return "order_" + this.$dayjs().format("YYYY-MM-DD_HH-mm-ss") + ".xls";
    },
    excelOrderFields: function () {
      return {
        "Адрес доставки": "pointAddress",
        Производитель: "manufacturer",
        "Группа прайса": "priceGroup",
        Наименование: "productName",
        Страна: "productCountry",
        "Срок годности": {
          field: "expiration",
          callback: (value) => {
            return `${this.$dayjs(String(value)).format("MM-YYYY")}`;
          },
        },
        "Цена, РОЦ": {
          field: "price",
          callback: (value) => {
            return `${value.toLocaleString().replace(/\./g, ",")}`;
          },
        },
        "Количество, шт": "quantity",
      };
    },
  },
  methods: {
    ...mapActions({
      getProductPrices: "products/GET_PRODUCT_PRICES",
      getProductTypes: "products/GET_PRODUCT_TYPES",
      getPoints: "points/GET_POINTS",
      createOrder: "orders/CREATE_ORDER",
      getOrders: "orders/GET_ORDERS",
      getOrderItems: "orders/GET_ORDER_ITEMS",
      getUser: "users/GET_USER",
      addSelectedPoints: "points/ADD_SELECTED_POINTS",
      removeSelectedPoints: "points/REMOVE_SELECTED_POINT",
      getProductsState: "products/GET_PRODUCTS_STATE",
      updateSelectedOrderItems: "orders/UPDATE_SELECTED_ORDER_ITEMS",
      getBasket: "baskets/GET_BASKET",
      upsertBasket: "baskets/UPSERT_BASKET",
    }),
    init: function () {
      this.$store.subscribe((mutation) => {
        switch (mutation.type) {
          case "products/ADD_SELECTED_PRODUCT_TYPES":
          case "products/REMOVE_SELECTED_PRODUCT_TYPES":
          case "products/EDIT_SELECTED_COLD_ZONE":
          case "products/EDIT_SELECTED_COUNTRY_BELARUS":
            this.filterProducts();
            break;
          case "products/SET_PRODUCT_PRICES":
            this.currentProductPrices = this.productPrices;
            break;
          case "baskets/SET_BASKET":
            this.canMakeOrder =
              this.basket && this.basket != null && this.basket.length > 0;

            if (!this.basket || this.basket == null || this.basket.length <= 0)
              this.dialogOrder = false;
            break;
        }
      });
    },
    initOrder: function () {
      const currentOrder = this.orders
        ? this.orders.find((current) => {
            return current.orderId === this.orderId;
          })
        : null;

      this.order = {
        number: currentOrder.number,
        created: currentOrder.created,
        items: this.orderItems,
      };
    },
    filterProducts: function () {
      if (
        (this.selectedProductTypes &&
          this.selectedProductTypes != null &&
          Object.keys(this.selectedProductTypes).length > 0) ||
        this.isColdZone ||
        this.isCountryBelarus
      ) {
        this.currentProductPrices = this.productPrices.filter((item) => {
          const type = this.selectedProductTypes[item.productTypeId];
          return type && type != null && type.value;
        });

        if (this.currentProductPrices && this.currentProductPrices.length == 0)
          this.currentProductPrices = this.productPrices;

        if (this.isColdZone)
          this.currentProductPrices = this.currentProductPrices.filter(
            (item) => {
              return item.isColdZone;
            }
          );

        if (this.isCountryBelarus)
          this.currentProductPrices = this.currentProductPrices.filter(
            (item) => {
              return item.country
                ? item.country.toLowerCase() == "беларусь"
                : false;
            }
          );
      } else this.currentProductPrices = this.productPrices;
    },
    viewOrder: async function () {
      await this.getBasket();

      this.order = {
        number: "",
        created: "",
        items: this.basket,
      };

      this.dialogOrder = true;
    },
    addPoints: function (points) {
      this.addSelectedPoints(points);
    },
    removePoint: function (point) {
      this.removeSelectedPoints(point);
    },
    onCancelOrder: function () {
      this.dialogOrder = false;
      this.order = {};
    },
    onSaveOrder: async function () {
      this.canMakeOrder = false;
      this.dialogOrder = false;
      await this.createOrder();
      await this.getOrders();
      this.$router.push("/orders");
    },
    updateQuantity: async function (item) {
      this.updateSelectedOrderItems(item);
      await this.upsertBasket(item);

      this.order = {
        number: "",
        created: "",
        items: Object.values(this.selectedOrderItems),
      };
    },
  },
  data: () => ({
    currentProductPrices: [],
    canMakeOrder: false,
    icons: {
      send: Icon.send,
      close: Icon.close,
      sigma: Icon.sigma,
      export: Icon.export,
    },
    dialogOrder: false,
    order: {},
  }),
  mounted: async function () {
    this.init();
    await this.getUser(this.user.userId);
    await this.getPoints(this.user.userId);
    await this.getProductsState();
    await this.getBasket();

    if (this.orderId != null) {
      await this.getOrders();
      await this.getOrderItems(this.orderId);
      this.initOrder();
    } else {
      await this.getProductTypes();
      await this.getProductPrices();
      this.canMakeOrder =
        this.basket && this.basket != null && this.basket.length > 0;
    }
  },
};
</script>
